import moment from 'moment';
const FORMAT = "DD-MM-YYYY"
const TIME_PERIODS = {
  QUARTER: "quarter",
  YTD: "ytd",
  MTD: "mtd",
  MONTH: "month",
  WEEK: "week",
  PROMO_WEEK: "promo_week",
  DAY: "day",
  YEAR: "year",
  NIELSEN: "nielsen"
}

export default{
  TIME_PERIODS,
  intervalForPeriod: function(timePeriod, year, month, day, period, promoWeekStart) {
    let result = {
      startDate: null,
      endDate: null
    }
    let ref = null
    switch (timePeriod) {
      case TIME_PERIODS.DAY:
        if(!month) {
          throw "Missing 'month' parameter when 'timePeriod' is 'DAY'"
        }
        if(!year) {
          throw "Missing 'year' parameter when 'timePeriod' is 'DAY'"
        }
        result.startDate = moment(`${period}-${month}-${year}`, FORMAT);
        result.endDate = moment(`${period}-${month}-${year}`, FORMAT);
        break;
      case TIME_PERIODS.WEEK:
        if(!year) {
          throw "Missing 'year' parameter when 'timePeriod' is 'WEEK'"
        }
        ref = moment(`${period}-${year}`, "WW-YYYY")
        result.startDate = moment(ref.clone().startOf("isoWeek").format(FORMAT), FORMAT)
        result.endDate = moment(ref.clone().endOf("isoWeek").format(FORMAT), FORMAT);
        break;
      case TIME_PERIODS.MONTH:
        if(!year) {
          throw "Missing 'year' parameter when 'timePeriod' is 'MONTH'"
        }
        ref = moment(`${period}-${year}`, "MM-YYYY")
        result.startDate = moment(ref.clone().startOf("month").format(FORMAT), FORMAT)
        result.endDate = moment(ref.clone().endOf("month").format(FORMAT), FORMAT);
        break;
      case TIME_PERIODS.QUARTER:
        if(!year) {
          throw "Missing 'year' parameter when 'timePeriod' is 'QUARTER'"
        }
        ref = moment(`${period}-${year}`, "Q-YYYY")
        result.startDate = moment(ref.clone().startOf("quarter").format(FORMAT), FORMAT)
        result.endDate = moment(ref.clone().endOf("quarter").format(FORMAT), FORMAT);
        break;
      case TIME_PERIODS.YEAR:
        ref = moment(`${period}`, "YYYY")
        result.startDate = moment(ref.clone().startOf("year").format(FORMAT), FORMAT)
        result.endDate = moment(ref.clone().endOf("year").format(FORMAT), FORMAT);
        break;
      case TIME_PERIODS.NIELSEN:
        if(!year) {
          throw "Missing 'year' parameter when 'timePeriod' is 'NIELSEN'"
        }
        ref = moment(`${4*period - 3}-${year}`, "WW-YYYY")
        result.startDate = moment(ref.clone().startOf("isoWeek").format(FORMAT), FORMAT)
        result.endDate = moment(ref.clone().add(21,"days").endOf("isoWeek").format(FORMAT), FORMAT);
        break;
      case TIME_PERIODS.PROMO_WEEK:
        if(!year) {
          throw "Missing 'year' parameter when 'timePeriod' is 'PROMO_WEEK'"
        }
        ref = moment(`${period}-${year}`, "WW-YYYY")
        result.startDate = moment(ref.clone().startOf("isoWeek").add(promoWeekStart - 1, "days").format(FORMAT), FORMAT)
        result.endDate = moment(ref.clone().endOf("isoWeek").add(promoWeekStart - 1,"days").format(FORMAT), FORMAT);
        break;
      case TIME_PERIODS.YTD:
        if(!day) {
          throw "Missing 'day' parameter when 'timePeriod' is 'YTD'"
        }
        if(!month) {
          throw "Missing 'month' parameter when 'timePeriod' is 'YTD'"
        }
        if(!year) {
          throw "Missing 'year' parameter when 'timePeriod' is 'YTD'"
        }
        ref = moment(`${day}-${month}-${year}`, "DD-MM-YYYY")
        result.startDate = moment(ref.clone().startOf("year").format(FORMAT), FORMAT)
        result.endDate = moment(ref.clone())
        break;
      case TIME_PERIODS.MTD:
        if(!day) {
          throw "Missing 'day' parameter when 'timePeriod' is 'MTD'"
        }
        if(!month) {
          throw "Missing 'month' parameter when 'timePeriod' is 'MTD'"
        }
        if(!year) {
          throw "Missing 'year' parameter when 'timePeriod' is 'MTD'"
        }
        ref = moment(`${day}-${month}-${year}`, "DD-MM-YYYY")
        result.startDate = moment(ref.clone().startOf("month").format(FORMAT), FORMAT)
        result.endDate = moment(ref.clone())
        break;
    }
    return result
  }
}